import React from 'react';
import { Provider as JotaiRoot } from 'jotai';
import LzSApp from '@lz-app/App';
import LzPAppBootstrap from './type';
import LzXAppBootstrapThemeSetup from './theme-setup';

export default function LzXAppBootstrap(props: LzPAppBootstrap) {
    // Set the global app variables
    LzSApp.init({
        WrapperTemplate: props.WrapperTemplate,
        modules: props.modules,
        logo_image: props.logo_image,
        base_bg_image: props.base_bg_image,
        login_bg_image: props.login_bg_image,
        register_bg_image: props.register_bg_image,
        forgot_pwd_bg_image: props.forgot_pwd_bg_image,
        powered_by_image: props.powered_by_image,
        powered_by_url: props.powered_by_url,
        hide_powered_by: props.hide_powered_by,
        date_format: props.date_format,
        time_format: props.time_format,
        datetime_format: props.datetime_format,
    });

    // Render the next level
    return (
        <React.Fragment>
            <JotaiRoot>
                <LzXAppBootstrapThemeSetup {...props} />
            </JotaiRoot>
        </React.Fragment>
    );
}
